import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Icon(props) {
  const { icon, className, onClick } = props;
  return (
    <FontAwesomeIcon className={className} icon={icon} onClick={onClick} />
  );
}

export default Icon;
